import React, { useEffect, useState } from 'react';
import { NavHashLink } from 'react-router-hash-link';
import { firestore } from './FirebaseConfig';
import {
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Avatar,
  CardActions,
  Button,
  IconButton,
  CircularProgress
} from '@mui/material';



const EgressBlog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const postsSnapshot = await firestore.collection('teamPosts').get();
        const fetchedPosts = postsSnapshot.docs.map((doc) => ({
          ...doc.data(),
          docId: doc.id,
        }));
        setPosts(fetchedPosts);
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    };

    fetchPosts();
  }, []);

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div id='egress-windows-blog' style={{
      width: '98%',
      margin: '0px auto',
      paddingTop: '50px',
      paddingBottom: '50px',
      '@media (max-width:420px)': {
        
        width: '98%',
        
        
      }   
    }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Egress Window Blog</h1>
      
      <Grid container spacing={6}>
        {posts.map((post) => (
          <Grid item key={post.docId} xs={12} sm={6} md={4} style={{ marginTop: '10px', width: '90vw' }}>
            <Card style={{
              backgroundColor: '#ffffff',
              height: '100%',
              margin: '10px',
              marginBottom: '25px',
              marginTop: '25px'
            }}>
              <CardMedia
                component="img"
                height="330px"
                image={post.media[0].src}
                alt="Post Image"
                style={{
                  paddingTop: '0px',
                  objectFit: 'cover',
                }}
              />
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <Avatar
                    src={post.avatar}
                    alt={post.displayName}
                    style={{ marginRight: '10px' }}
                  />
                  <Typography variant="subtitle2" ml={4} style={{ marginLeft: '10px' }}>
                    {post.displayName}
                  </Typography>
                </Box>
                <Typography variant="h6" component="h2" gutterBottom>
                  {post.title}
                </Typography>
                <Typography variant="body1" color="textSecondary" mb={2}>
                  {truncateText(post.content, 150)}
                </Typography>
                <Box display="flex" alignItems="right">                  
                  <CardActions disableSpacing={true} sx={{width: '100%', display: 'flex', flexDirection: 'row', verticalAlign: 'bottom', alignItems: 'right', flexWrap: 'wrap'}}>
                       <NavHashLink
                      to={`/post-page/${post.docId}#article`}
                      style={{ textDecoration: 'none' }}
                        >
                    <Button size="large" backgroundColor="#DCD7D4" sx={{color: '#121212', textAlign: 'center', backgroundColor: '#DCD7D4', paddingLeft: '16px', paddingRight: '16px'}}>Read More</Button>
                   </NavHashLink>
                   </CardActions>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}


      </Grid>
          
    </div>
  );
};

export default EgressBlog;
